module.exports = __webpack_public_path__ + "img/email.0b8be7fd.svg";